import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  CalendarCheck2,
  Clock4,
  Download,
  Menu,
  X
} from "lucide-react";

export default function SideBar() {
  const [collapsed, setCollapsed] = useState(true);
  const [selectedTab, setSelectedTab] = useState(() => {
    // Get stored selected tab from localStorage or default to the first tab
    return localStorage.getItem("selectedTab") || "/schedule";
  });

  const navItems = [
    { label: "Schedule Request", to: "/schedule", icon: CalendarCheck2 },
    { label: "Tardiness Notice", to: "/tardiness", icon: Clock4 },
    { label: "Reports", to: "/reports", icon: Download },
  ];

  // Update the selected tab in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("selectedTab", selectedTab);
  }, [selectedTab]);

  return (
    <aside
      className={`h-screen sticky top-0 z-20 bg-white/10 backdrop-blur-md text-white p-4 shadow-lg border-r border-white/20 transition-[width] duration-300 ease-in-out ${collapsed ? 'w-20' : 'w-64'}`}
    >
      <div className="flex justify-between items-center mb-6 transition-all duration-100">
        <div
          className={`text-xl font-bold text-black/80 tracking-wide whitespace-nowrap overflow-hidden transition-opacity duration-100 ${collapsed ? 'opacity-0 w-0' : 'opacity-100 w-auto'}`}
        >
          Delight Restaurant
        </div>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-black/30 hover:text-black/60 text-sm"
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <Menu size={20} /> : <X size={20} />}
        </button>
      </div>

      <nav className="space-y-2">
        {navItems.map(({ label, to, icon: Icon }) => (
          <NavLink
            key={label}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 py-3 rounded-md transition-all duration-200 whitespace-nowrap overflow-hidden text-ellipsis ${isActive
                ? "text-yellow-300 bg-white/20 font-semibold border-l-4 border-yellow-300"
                : "text-gray-900 hover:bg-white/10 hover:text-black/50"
              }
              ${collapsed ? "px-3" : "px-2"}` 
            }
            onClick={() => setSelectedTab(to)} // Update selectedTab when a tab is clicked
          >
            <div className="min-w-[24px] flex justify-center" title={label}>
              <Icon size={24} />
            </div>
            <span className={`transition-opacity duration-300 ${collapsed ? 'opacity-0 w-0' : 'opacity-100 w-auto'}`}>
              {label}
            </span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
